/**
 * The Biology tools module, loaded at run time from the cell-lab deploy on the CDN and mounted directly in the page
 * (no iframe; biology-cell-explorer-prd.md §8.7 S3, D-CELL-41; platform D-STOOL-11). A cell-lab merge reaches Study
 * without copying code into this repository.
 */

/** Matches the module's own `StudyHost` (events and saved state for the student's account). */
export interface BiologyModuleStudyHost {
  readonly enabled: boolean;
  record(event: {
    kind: 'tool_used' | 'prediction_answered' | 'check_answered';
    tool_key: string;
    item_id?: string;
    choice?: string;
    correct?: boolean;
  }): Promise<void>;
  loadState(toolKey: string): Promise<string | null>;
  saveState(toolKey: string, state: string): Promise<void>;
}

export interface BiologyModule {
  mountCellExplorer(
    host: HTMLElement,
    options: {
      search: string;
      onSearchChange?: (search: string) => void;
      studyHost?: BiologyModuleStudyHost;
    },
  ): () => void;
  /** The cell-lab commit the module was built from. */
  version?: string;
}

/**
 * Study serves the module at the same path in every environment. The dev proxy serves only public module assets;
 * student account APIs remain on the local backend. A missing asset is a loading error, never an iframe fallback.
 */
export function biologyModuleUrl(
  env: { VITE_BIOLOGY_MODULE_URL?: string } = import.meta.env,
): string {
  return env.VITE_BIOLOGY_MODULE_URL?.trim() || '/study-tools/cell-explorer/embed/embed.js';
}

/** Loads the module from its URL (a real network import, not bundled). */
export function loadBiologyModule(url: string): Promise<BiologyModule> {
  return import(/* @vite-ignore */ url) as Promise<BiologyModule>;
}
